import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "left-actions" }
const _hoisted_2 = { class: "left-actions" }
const _hoisted_3 = { class: "left-actions" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = { style: {"width":"170px"} }

import { List } from 'ant-design-vue';
import { RecycleScroller } from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import { ref } from "vue";
import { useRouter } from "vue-router";
import { onMounted, onUnmounted } from "vue";
import { TelegramClient } from "@/websocket/Client";
import * as telegram from "@/api/telegram";

import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { dataManager } from "@/common/dataManager";

export default /*@__PURE__*/_defineComponent({
  __name: 'TaskDetailManager',
  emits: ["update:visible"],
  setup(__props, { emit: __emit }) {

const account = localStorage.getItem("username") || "";
const client = TelegramClient.getInstance();
const router = useRouter();
const recycleScrollerRef = ref(RecycleScroller);
 
const taskLogList = ref<telegram.tg.TaskLogItem[]>([]);
const taskRspList = ref<telegram.tg.MDM_GR_EXECUTE_TASK_RSP[]>([]);
const selectedItem = ref(0);
var taskUpdataLogList:any = [];
      //获取系统时间
      const formatDateTime =(sendTime)=> {

      var strTime =  new Date(Number(sendTime) * 1000).toLocaleString()

        return strTime
    }
 
      // 根据条件返回颜色
      const getColor =(errCode)=> {
        if(errCode === 0)
        {
            return '#52c41a';
        }
        else
        {
          return '#ff4d4f';
        }
    }

    const  getTaskName = (index)=>{
        var strName =  "任务索引" +  index ;
        return strName;
    }
 
    const  getPercent = (count,total)=>{
        var percent = Math.floor((parseInt(count)/parseInt(total)) * 100);
        return percent;
    }


    const  getTaskProgress = (count,total)=>{
        var strProgress = "私信" + "(" + count + "/" + total + ")";
        return strProgress;
    }
 

   // 处理列表项点击事件
    const handleItemClick = (item)=>{
      selectedItem.value = item.taskId; // 设置当前选中的列表项 ID
      console.log('Clicked item:', item);
    }
    
      const emit = __emit;

    const handleButton = ()=>{
      //recycleScrollerRef.value.scrollToItem(28);
      emit("update:visible", false);
  }

  const exportData = ()=>{
    var fileName = "export.xlsx";
    let copyArr = JSON.parse( JSON.stringify(taskUpdataLogList) );
    var jsonData = copyArr;
    for (let i = 0; i < jsonData.length; i++) {
        const element = jsonData[i];
        jsonData[i].sendTime = formatDateTime(element.sendTime);
     }
    if(jsonData.length > 0)
    {
      const worksheet = XLSX.utils.json_to_sheet(jsonData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(workbook, fileName);
    }

  }

  
  const handTaskUpdate = (data)=>{
    var newMessage = data.detail;
     //console.log('收到新消息:', newMessage);

     var bFind = false;
          for (let i = 0; i < taskRspList.value.length; i++) {
              const element = taskRspList.value[i];
              if(element.index == newMessage.index)
              {
                taskRspList.value[i] = newMessage;
                bFind = true;
                break;
              }
          }
          if(bFind)
          {

          }
          else
          {
              taskRspList.value.push(newMessage);
          }


     if(newMessage.errCode == 1)
     {

     }
     else
     {
        //搜索不到用户不能走日志这块。
        let nowTime = Math.floor(new Date().getTime() / 1000);
        let taskLost =  telegram.tg.TaskLogItem.create();   
        taskLost.taskId = new Date().getTime() + Math.random()*1000;
        taskLost.phone = newMessage.sender;
        taskLost.receiver = newMessage.receiver;
        taskLost.errorMsg = newMessage.reason;
        taskLost.errCode = -1000;
        taskLost.sendTime = nowTime;
        taskUpdataLogList.push(taskLost);
        taskLogList.value = taskUpdataLogList;
        recycleScrollerRef.value.handleResize();
        console.log("fdadfasdf round="+taskLost.taskId);
     }

     
  }

  const handTaskLogUpdate = (data)=>{
    var newMessage = data.detail;
    var bFind = false;
    console.log('收到新消息2:', newMessage);
    if(newMessage.errCode == 10000) return;
    if(newMessage.receiver == "")
    {
      //newMessage.receiver == newMessage.receiver_id;
    }
    for (let i = 0; i < taskUpdataLogList.length; i++) {
        const element = taskUpdataLogList[i];
        if(element.taskId == newMessage.taskId)
        {
          taskLogList.value[i] = newMessage;
           bFind = true;
           break;
        }
     }
     if(bFind)
     {

     }
     else
     {
       taskUpdataLogList.push(newMessage);
       taskLogList.value = taskUpdataLogList;
       recycleScrollerRef.value.handleResize();
     }

  }
 

  // 修改执行任务的处理函数
const handleViewLog = async (taskIds: number[]) => {
    const sesionId = localStorage.getItem("session") || "";
    client.getTaskLogEvent(account,sesionId);
    // dataManager.instance.taskLogList.value = response.list;
    // taskLogList.value = dataManager.instance.taskLogList.value;
    // console.log(response);

}


  onMounted(() => {
      //taskLogList.value = dataManager.instance.taskLogList.value;
      console.log("onMounted-1");
      taskUpdataLogList = [];
      const client = TelegramClient.getInstance();
      client.addTaskUpdateListener(handTaskUpdate);
      client.addTaskLogUpdateListener(handTaskLogUpdate);
      handleViewLog([0]);

  });

  
  onUnmounted(() => {
    client.removeTaskUpdateListener(handTaskUpdate);
    client.removeTaskLogUpdateListener(handTaskLogUpdate);
    });
 

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_progress = _resolveComponent("a-progress")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!

  return (_openBlock(), _createBlock(_component_a_layout, { style: { background: 'none' } }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, { style: { background: 'none',height:'100px' } }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_a_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: handleButton
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode("返回")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: exportData
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("导出excel")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_a_space, null, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createElementVNode("p", { style: {"font-size":"20px"} }, "任务详情", -1)
              ])),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout, { style: { background: 'none' } }, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_space, { style: { width: '100%', display: 'flex', justifyContent: 'space-between'} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, {
                    style: _normalizeStyle([{"width":"100%"}, { background: 'none',border: 'none' }])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { style: {"width":"150px"} }, {
                              default: _withCtx(() => _cache[3] || (_cache[3] = [
                                _createTextVNode("时间")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { style: {"width":"150px"} }, {
                              default: _withCtx(() => _cache[4] || (_cache[4] = [
                                _createTextVNode("发送者")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { style: {"width":"150px"} }, {
                              default: _withCtx(() => _cache[5] || (_cache[5] = [
                                _createTextVNode("接收者")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { style: {"width":"150px"} }, {
                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createTextVNode("接收者ID")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { style: {"width":"260px"} }, {
                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createTextVNode("状态")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(RecycleScroller), {
                ref_key: "recycleScrollerRef",
                ref: recycleScrollerRef,
                class: "scroller",
                items: taskLogList.value,
                "item-size": 50,
                "key-field": "taskId"
              }, {
                default: _withCtx(({ item }) => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_a_list_item, {
                      class: _normalizeClass({ 'selected': selectedItem.value === item.taskId }),
                      onClick: ($event: any) => (handleItemClick(item))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { style: {"width":"150px"} }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(formatDateTime(item.sendTime)), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_a_col, { style: {"width":"150px"} }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.phone), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_a_col, { style: {"width":"150px"} }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.receiver), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_a_col, { style: {"width":"150px"} }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.receiver_id), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_a_col, {
                              style: _normalizeStyle([{"width":"260px"}, { color: getColor(item.errCode) }])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.errorMsg), 1)
                              ]),
                              _: 2
                            }, 1032, ["style"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["class", "onClick"])
                  ])
                ]),
                _: 1
              }, 8, ["items"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout_sider, {
            width: 280,
            style: { background: 'none' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_list, {
                "item-layout": "horizontal",
                "data-source": taskRspList.value
              }, {
                renderItem: _withCtx(({ item }) => [
                  _createVNode(_component_a_card, {
                    title: getTaskName(item.index),
                    style: {"width":"200px"},
                    class: "rounded-card"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(getTaskProgress(item.count,item.total)), 1),
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_a_progress, {
                          percent: getPercent(item.count,item.total),
                          size: "small"
                        }, null, 8, ["percent"])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["title"])
                ]),
                _: 1
              }, 8, ["data-source"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_footer, { style: { background: 'none' } }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode("Footer")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})